var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid grid--gap-0" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("rb-loading", { attrs: { loading: _vm.submitted } }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.submitted,
                expression: "!submitted",
              },
            ],
            staticClass: "rb-login-overlay rb-login",
          },
          [
            !_vm.isMobile
              ? _c(
                  "header",
                  {
                    staticClass: "hide-md",
                    attrs: { "aria-label": "rb-login" },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translation("private_sale.loginToShopLabel")
                        ) +
                        "\n      "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("p", { staticClass: "rb-login-overlay__title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.translation("private_sale.loginTitle")) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "rb-login-overlay__subtitle" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.translation("private_sale.loginSubtitleTwo")) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _vm.error && _vm.errorMessage
              ? _c("div", [
                  _c("p", { staticClass: "rb-login-overlay__error" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.errorMessage) + "\n        "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "form",
              {
                attrs: { name: "emailForm", novalidate: "novalidate" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.submit($event)
                  },
                },
              },
              [
                _c("rb-textfield", {
                  staticClass: "rb-login-overlay__email",
                  attrs: {
                    id: "emailAddress",
                    name: "emailAddress",
                    type: "email",
                    required: true,
                    label: _vm.translation("private_sale.emailAddressLabel"),
                    error: _vm.translation("private_sale.emailAddressError"),
                    validation: _vm.$v.emailAddress,
                  },
                }),
                _vm._v(" "),
                _c("rb-textfield", {
                  staticClass: "rb-login__password",
                  attrs: {
                    id: "password",
                    name: "password",
                    type: "password",
                    required: true,
                    label: _vm.translation("private_sale.passwordLabel"),
                    error: _vm.translation("private_sale.passwordError"),
                    validation: _vm.$v.password,
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "rb-login__password-forgot" }, [
                  _c(
                    "button",
                    {
                      staticClass: "rb-login__password-forgot--text",
                      attrs: { "data-analytics_available_call": "0" },
                      on: {
                        click: function ($event) {
                          if ($event.target !== $event.currentTarget) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.toggleForgotPasswordForm($event)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.translation("private_sale.forgotPasswordLabel")
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "rb-login-overlay__action-group" },
                  [
                    _c(
                      "button",
                      {
                        ref: "submit",
                        staticClass: "rb-btn rb-btn--black btn-full-width",
                        attrs: {
                          type: "submit",
                          "data-element-id": "X_X_PrivateSaleLogin_Login",
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.translation("private_sale.login")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isSocialLoginEnabled
                      ? [
                          _c("div", { staticClass: "btn-or-separator" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.translation(
                                    "private_sale.registrationOrSeparatorLogin"
                                  )
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("rb-facebook-login", {
                            ref: "btnFb",
                            staticClass: "btn-full-width",
                            attrs: {
                              "section-login": "private_sale_login",
                              "is-frame-advisor": _vm.isFrameAdvisor,
                              "cat-entry": _vm.selectedProduct.catEntryId,
                            },
                            on: {
                              click: _vm.fbLoginAnalyticsTracking,
                              eventFacebookLogin: _vm.updateFieldsFromFbLogin,
                            },
                          }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "rb-login__not-member" }, [
                      _c("span", [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.translation("private_sale.notAMemberLabel")
                            ) +
                            "\n              "
                        ),
                        _c(
                          "button",
                          {
                            attrs: {
                              type: "button",
                              "data-element-id":
                                "X_X_PrivateSaleLogin_CreateAccount",
                            },
                            on: { click: _vm.showRegisterForm },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.translation(
                                    "private_sale.createAccountLabel"
                                  )
                                ) +
                                "\n              "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.showForgotPasswordForm
              ? _c("rb-forgot-password-form")
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }